import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ROUTES from 'routes';
import { useAppDispatch } from 'hooks';
import { clearState } from 'redux/auth/actions';
import { reactivateAccount } from 'redux/account/actions';
import { Spinner } from 'components/ui';
import Tile from 'components/ui/Tile';
import Button from 'components/ui/Button';
import Typography from 'components/ui/Typography';
import { showApiErrorToast } from 'api';
import { createCustomToast } from 'services/toasts';

import css from './AccountInactiveError.module.scss';

const AccountInactiveError: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const reactivate = () => {
        setIsLoading(true);
        dispatch(reactivateAccount())
            .unwrap()
            .then(() => {
                navigate(ROUTES.HOME);
                createCustomToast('success', t('LoginForm.AccountReactivated'));
            })
            .catch((err) => {
                showApiErrorToast(err, t);
                setIsLoading(false);
            });
    };

    return (
        <div className={css.containerInactive}>
            <Tile>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <>
                        <Tile.Header>{t('AccountInactive.InactiveAccount')}</Tile.Header>
                        <Tile.Item>
                            <Typography color="gray2">
                                <Trans i18nKey="AccountInactive.AccountDeletionWarning">
                                    If you do not do anything, your account will be deleted within 30 days. You may also
                                    <a onClick={reactivate}>reactivate your account</a>
                                </Trans>
                            </Typography>
                            <Button
                                withPadding
                                blocked
                                className={css.margin}
                                onClick={() => {
                                    dispatch(clearState());
                                    navigate(ROUTES.LANDING);
                                }}
                            >
                                {t('Common.ReturnHome')}
                            </Button>
                        </Tile.Item>
                    </>
                )}
            </Tile>
        </div>
    );
};
export default AccountInactiveError;
